package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.ui.EntityComponent
import ai.flowstorm.studio.model.ProfileRecord
import ai.flowstorm.studio.model.User
import ai.flowstorm.studio.resources.space.ProfileRecordResource
import ai.flowstorm.studio.resources.UserResource
import io.kvision.i18n.tr
import io.kvision.panel.SimplePanel
import io.kvision.panel.TabPanel
import io.kvision.panel.tabPanel
import io.kvision.state.ObservableList
import io.kvision.state.observableListOf
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

class ProfileRecordUserViewer(val model: UserResource) :
    SimplePanel(),
    EntityComponent<User>
{
    override var entity: User? = null

    private val mainScope = MainScope()

    private val searchForm = ProfileRecordUserSearchForm(this)

    private var recordTab: TabPanel? = null

    override fun load(entity: User): User {
        removeAll()
        this.entity = entity
        add(searchForm.load(entity))
        mainScope.launch {
            delay(150)
            val query = ProfileRecordResource.buildQuery(entity, ProfileRecordUserSearchForm.FormData())
            val profileRecords = observableListOf<ProfileRecord>().apply {addAll(ProfileRecordResource(entity).load(query)) }
            loadRecords(profileRecords)
        }
        return entity
    }

    fun loadRecords(profileRecords: ObservableList<ProfileRecord>) {
        recordTab?.let { remove(it) }
        mainScope.launch {
            delay(150)
            tabPanel {
                addTab(tr("Record"), ProfileRecordTable(this@ProfileRecordUserViewer.entity!!, profileRecords)).also {
                    recordTab = it
                }
            }
        }
    }

    override fun load(id: Id): User {
        val user = model.get(id)
        return load(user)
    }
}

